import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import { themeValue, withSiteTheme } from '../../../../config/css';

const DocumentBrowseCardLinkTheme = {
  default: css`
    display: block;

    &:focus-visible {
      outline-offset: 0px;
    }

    &[data-type='videos'] {
      max-height: 11.42rem;
      overflow: hidden;

      .no-image & {
        max-height: none;
      }
    }

    img {
      height: 100%;
      width: 100%;

      .horizontal & {
        max-height: 14rem;
        max-width: 14rem;
      }

      .carousel & {
        background-color: ${themeValue('colors', 'white')};
      }
    }

    ${breakpoint('desktop')`
      img {
        .horizontal & {
          max-height: 20rem;
          max-width: 20rem;
        }
      }
    `}
  `,
};

const DocumentBrowseCardLink = styled.a.attrs((props) => ({
  className: [props.className, 'document-browse-card__link'].join(' '),
}))`
  ${withSiteTheme(DocumentBrowseCardLinkTheme)}
`;

export default DocumentBrowseCardLink;
